import React, { useState } from 'react';
import { graphql } from 'gatsby';
import { Layout } from '../components/Layout';
import {
  LegalPageBody,
} from '../components/legal';
import {
  SimpleHero,
} from '../components/common';
import {
  useMousePosition,
  useDimensions,
  useScrollPosition,
} from '../util/hooks';
import { isClient, arraysEqual } from '../util/helpers';

const LegalPageTemplate = (props) => {
  const {
    data: {
      page: {
        data: pageData,
      },
    },
    location,
  } = props;
  const {
    heroTitle,
    sections,
    metaTitle,
    metaDescription,
    openGraphImage,
  } = pageData;
  const seoData = {
    metaTitle,
    metaDescription,
    openGraphImage,
  };
  const {
    x: cursorX,
    y: cursorY,
  } = useMousePosition();
  const {
    viewportWidth,
    viewportHeight,
    documentHeight,
  } = useDimensions();
  const viewportTopPos = useScrollPosition();
  if (isClient) document.documentElement.style.setProperty('--bg-colour', '#FFFFF4');
  const [sectionsInView, setSectionInView] = useState([]);
  const activeSection = sectionsInView.length > 0 ? sectionsInView.reduce((a, b) => Math.min(a, b)) : 0;
  const sectionInViewHandler = (sectionIndex, isInView) => {
    let newSectionsInView = [...sectionsInView];
    const indexExists = newSectionsInView.includes(sectionIndex);
    if (isInView) {
      // Intersection Observer has notified us section has come into view
      // indexExists prevents us from adding duplicates
      if (!indexExists) {
        newSectionsInView = [
          ...sectionsInView,
          sectionIndex,
        ];
      }
    } else {
      // Intersection Observer has notified us section is now out of view
      newSectionsInView = sectionsInView.filter(index => index !== sectionIndex);
    }
    if (!arraysEqual(sectionsInView, newSectionsInView)) {
      // Only if a new section has come into, or an existing section has come
      // out of view, we update the state
      setSectionInView(newSectionsInView);
    }
  };
  return (
    <Layout
      location={location}
      seoData={seoData}
      cursorX={cursorX}
      cursorY={cursorY}
      viewportWidth={viewportWidth}
      viewportHeight={viewportHeight}
      documentHeight={documentHeight}
      viewportTopPos={viewportTopPos}
    >
      <SimpleHero
        title={heroTitle.text}
      />
      <LegalPageBody
        activeSection={activeSection}
        sectionInViewHandler={sectionInViewHandler}
        sections={sections}
      />
    </Layout>
  );
};

export default LegalPageTemplate;

export const pageQuery = graphql`
  query LegalPageBySlug($uid: String!) {
    page: prismicLegal(uid: { eq: $uid }) {
      data {
        heroTitle: hero_title {
          text
        }
        sections {
          content {
            html
          }
          sectionHeading: section_heading {
            text
          }
        }
        metaTitle: meta_title {
          html
          text
        },
        metaDescription: meta_description {
          html
          text
        },
        openGraphImage: open_graph_image {
          alt
          copyright
          url
        }
      }
    }
  }
`;
